import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ForYouSection() {
  const criteria = ['Necesitas recuperar la paz que sientes que has perdido.', 'Deseas fortalecer tu fe más allá de lo que conoces en teoría.', 'Quieres desarrollar hábitos espirituales consistentes que realmente duren.', 'Estás atravesando una etapa de incertidumbre y necesitas un ancla.', 'Deseas aprender a confiar en Dios de manera más profunda y real.', "Anhelas vivir desde la fe y no desde el miedo, sintiéndote merecedor de recibir la Provisión de Dios."];
  return <section className="w-full bg-[#F7F2E7] py-20 px-6" data-id="element-114" data-mp="1u370zzkrvx5j">
      <div className="max-w-3xl mx-auto" data-id="element-115" data-mp="1u5t7dvvxg6m6">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-[#0A1535] mb-12" data-id="element-116" data-mp="1z3cm0wwjelen">
          Este programa es para ti si…
        </motion.h2>

        <div className="space-y-6" data-id="element-117" data-mp="5l5qrkr75g23">
          {criteria.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-118" data-mp="1levb3qq6br8" data-mpi={index}>
              <CheckCircle2 className="w-6 h-6 text-[#C9A24B] flex-shrink-0 mt-1" data-id="element-119" data-mp="3iu1s9jc8osnq" />
              <span className="text-lg text-[#0A1535]" data-id="element-120" data-mp="3e0yxx8zn1f6h">{item}</span>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-121" data-mp="3a0yh5hp2grw9">
          <motion.a href="https://pay.hotmart.com/A105236382M" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gradient-to-r from-[#C9A24B] to-[#E0B756] text-white font-bold text-lg px-10 py-5 rounded-full shadow-lg hover:shadow-2xl transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756] focus-visible:ring-offset-2 focus-visible:ring-offset-[#F7F2E7]" data-id="element-122" data-mp="3512h1tjhpklz">
            QUIERO COMENZAR MI MÉTODO R.E.V.E.L.A.
          </motion.a>
        </div>
      </div>
    </section>;
}